import { render, staticRenderFns } from "./heatmap_menu.vue?vue&type=template&id=d6c66c6c&scoped=true&lang=pug&"
import script from "./heatmap_menu.vue?vue&type=script&lang=js&"
export * from "./heatmap_menu.vue?vue&type=script&lang=js&"
import style0 from "./heatmap_menu.vue?vue&type=style&index=0&id=d6c66c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c66c6c",
  null
  
)

export default component.exports